import React from "react";

const NavItemGame = ({title, onClick, active, iconClass}) => {

    return <button
        className={`nav-list__item  nav-list__item--icon ${active ? 'nav-list__item--active' : ''}`}
        onClick={onClick}
        disabled={active}>
        <span className="nav-list__icon">
            <span className={iconClass}/>
        </span>
        <span className="nav-list__item-name">{title}</span>
    </button>
};

export default NavItemGame;